export function useDateUtils(lang) {
  
  const idioma = lang == "pt" ? "pt-PT" : "en-uk" ;

  const formatterdayname =
  new Intl.DateTimeFormat(idioma, {
    weekday: "short"
  });


 const formattermontname =
  new Intl.DateTimeFormat(idioma, {
    month: "short"
  });

  const formatter =
  new Intl.DateTimeFormat(idioma, {
    day: "2-digit"
  });


  function addOneDay(date) {
    date.setDate(date.getDate() + 1);
  }

  function addOneMonth(date) {
    date.setMonth(date.getMonth() + 1);
  }

  function addNMonths(date,n) {
    date.setMonth(date.getMonth() + n);
  }

  function removeNMonths(date,n) {
    date.setMonth(date.getMonth() - n);
  }

  function removeOneMonth(date) {
    date.setMonth(date.getMonth() - 1);
  }

  function getMonthObject(dateForMonth){
    let date = new Date(dateForMonth); // create a new Date object for each day
    return {
      label: formattermontname.format(date).toUpperCase(),
      value: formattermontname.format(date),
      year: date.getFullYear(),
      month: date.getMonth(),
      date: date,
    };
  }

  function getDayObject(startDate, numberWeekDay) {
    let date = new Date(startDate); // create a new Date object for each day
    date.setHours(0, 0, 0, 0);
    return {
      label: formatterdayname.format(date).charAt(0).toUpperCase(),
      number: formatter.format(date),
      value: numberWeekDay,
      date: date,
    };
  }

  function getPreviousWeek(date) {
    let startDate = new Date(date);
    startDate.setDate(startDate.getDate() - 7);
    return startDate;
  }

  function getPrevious2Week(date) {
    let startDate = new Date(date);
    startDate.setDate(startDate.getDate() - 14);
    return startDate;
  }

  function getNumberWeekDay(number) {
    if (number < 6) {
      return number + 2;
    }
    return 1;
  }

  return {
    addOneDay,
    getDayObject,
    getPreviousWeek,
    getNumberWeekDay,
    getPrevious2Week,
    getMonthObject,
    addOneMonth,
    removeOneMonth,
    removeNMonths,
    addNMonths
  };
}
